import maplibregl from 'maplibre-gl';

let markerHeight = 75,
  markerRadius = 10,
  linearOffset = 25;
const popupOffsets = {
  top: [0, 0],
  'top-left': [0, 0],
  'top-right': [0, 0],
  bottom: [0, -markerHeight],
  'bottom-left': [
    linearOffset,
    (markerHeight - markerRadius + linearOffset) * -1,
  ],
  'bottom-right': [
    -linearOffset,
    (markerHeight - markerRadius + linearOffset) * -1,
  ],
  left: [markerRadius, (markerHeight - markerRadius) * -1],
  right: [-markerRadius, (markerHeight - markerRadius) * -1],
};

export const hoverPopup = new maplibregl.Popup({
  closeButton: false,
  closeOnClick: true,
  offset: popupOffsets,
  className: 'terrestra-popup',
});

export const fixedPopup = new maplibregl.Popup({
  closeButton: true,
  closeOnClick: false,
  offset: popupOffsets,
  className: 'terrestra-popup',
});

export const geoFencePopup = new maplibregl.Popup({
  closeButton: true,
  closeOnClick: true,
  offset: {
    top: [0, 0],
    'top-left': [0, 0],
    'top-right': [0, 0],
    bottom: [0, -50],
    'bottom-left': [50, 100],
    'bottom-right': [50, 50],
    left: [50, 50],
    right: [50, 50],
  },
  className: 'geofencePopup',
});
